import React from 'react'
import AccountSetting from './AccountSetting';

const Setting = () => {
  return (
    <div>
      <AccountSetting/>
    </div>
  )
}

export default Setting;